var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui red message"},[_c('div',{staticClass:"header"},[_vm._v("查無此站或格式錯誤")]),_vm._v(" "),_c('p',[_vm._v("\n    請輸入起迄站、時間、車種即可。「中壢 新竹」「新左營 鳳山 週四」「高雄 嘉義 1/18 自強號」。可用 1/18、1月18日、1-18、星期四、週四。可以輸入車種以過濾「台北 花蓮 傾斜式」「中壢 台北 對號」。\n    "),_c('router-link',{attrs:{"to":{
          name: 'About'
      }}},[_vm._v("詳細說明")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44ba4ecc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/SearchError.vue
// module id = n4jg
// module chunks = 1